import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      {/* Main footer */}
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Brand + Newsletter */}
          <div className="lg:w-2/5">
            <div className="flex items-center gap-1.5 mb-6">
              <span className="text-xl font-semibold tracking-tight">oopbuyspread</span>
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
            </div>

            {/* Newsletter */}
            <div className="mb-8">
              <p className="text-sm text-background-300 mb-3">{t('footer.newsletter')}</p>
              <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="email"
                  placeholder={t('footer.newsletter_placeholder')}
                  className="flex-1 px-4 py-2.5 rounded-full bg-transparent border border-background-700 text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-background-400 transition-colors"
                />
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-send-plane-fill"></i>
                </button>
              </form>
            </div>

            <p className="text-lg md:text-xl font-heading text-background-200 leading-relaxed">
              {t('footer.tagline_line1')}<br />
              {t('footer.tagline_line2')}
            </p>
          </div>

          {/* Right - Link columns */}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{t('footer.col1_title')}</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">{t('footer.home')}</Link>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.categories')}</span>
                <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">{t('footer.guide')}</Link>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.faq')}</span>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{t('footer.col2_title')}</h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.privacy')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.terms')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.impressum')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.sitemap')}</span>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{t('footer.col3_title')}</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">kaspreadsheet.com</a>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.res_spreadsheet_finder')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.res_qc_guide')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.res_shipping')}</span>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{t('footer.col4_title')}</h4>
              <div className="flex flex-col gap-2.5">
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.contact')}</span>
                <span className="text-sm text-background-400 cursor-pointer">{t('footer.support_email')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-800">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            {['ri-twitter-x-line', 'ri-instagram-line', 'ri-telegram-line', 'ri-reddit-line'].map((icon, i) => (
              <span key={i} className="w-8 h-8 flex items-center justify-center rounded-lg border border-background-700 text-background-400 hover:text-background-100 hover:border-background-500 transition-colors cursor-pointer">
                <i className={`${icon} text-sm`}></i>
              </span>
            ))}
          </div>
          <span className="text-xs text-background-500 cursor-pointer">{t('footer.privacy')}</span>
        </div>
      </div>
    </footer>
  );
}